<template>
    <div
      class="modal fade createNewModal"
      id="AddPromotionModal"
      tabindex="-1"
      ref="addAddPromotionModalRef"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content p-15 p-md-40">
          <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
            <h5 class="modal-title fw-bold text-black">
          </h5>
          </div>
          <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
            <h5>Vous voulez mettre en promotion: {{ selectedProduit?.title }} qui coûte {{ selectedProduit?.price }} FCFA</h5>
          <Form ref="promotionForm" @submit="addPromotion" :validation-schema="promotionSchema">
            <div class="row">
                <div class="col-md-12">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                      Prix promo <span class="text-danger">*</span>
                    </label>
                    <Field name="sale_price" type="text" v-model="sale_priceProd"
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le nouveau prix"/>
                  <ErrorMessage name="sale_price" class="text-danger"/>
                  </div>
                </div>
              <button
                class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
                type="submit"
              >
                Envoyer
              </button>
            </div>
          </Form>
          </div>
          <button
            type="button"
            class="btn-close shadow-none"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { ref, onMounted, watch} from 'vue';
  import { Form, Field, ErrorMessage } from 'vee-validate';
  import * as Yup from 'yup';
  import ApiService from '@/services/ApiService';
  import { error, hideModal, success } from '@/utils/utils';
  import { useRouter, useRoute } from 'vue-router';
  import { Produit } from '@/models/Produit';
import axios from 'axios';
  
  export default {
    name: "AddPromotionModal",
    components: {
      Form,
      Field,
      ErrorMessage,
    },
    props: {
      selectedProduit: Object as () => Produit | undefined,
    },
    setup: (props, { emit }) => {
  
      const promotionSchema = Yup.object().shape({
        sale_price: Yup.number().typeError("Veuillez entrer des nombres").required("Le prix est obligatoire"),
      });
  
      const promotionForm =  ref<Produit | null>(null);
      const addAddPromotionModalRef = ref<null | HTMLElement>(null);
      //const router = useRouter();
      const userForm = ref<Produit>();
      const route = useRoute();
      const  produits = ref();
      const sale_price = ref();

    function getProduit(id:number) {
      ApiService.get("/produits/"+id.toString())
        .then(({ data }) => {
          for (const key in data.data) {
            userForm.value?.setFieldValue(key, 
            (typeof data.data[key] === 'object' && data.data[key] !== null)? data.data[key].id :data.data[key]
          );
          }
      })
      .catch(({ response }) => {
        error(response.message);
      });
    }
    
      const selectedProduit = ref<Produit | undefined>(undefined);
      const selectedProduitId = ref<number>();
        const sale_priceProd = ref<number>();
  
      const addPromotion = async (values, {resetForm}) => {
        const promotionData = {
          produitId: selectedProduit.value?.id,
          is_sale: selectedProduit.value?.is_sale,
          sale_price : sale_priceProd.value !== undefined ? parseInt(sale_priceProd.value.toString()) : 0
        };
        console.log('rfjfl', promotionData)
      ApiService.post("/startPromotions", promotionData)
        .then(({ data }) => {
          if (data.code == 200) {
          success(data.message);
          resetForm();
          hideModal(addAddPromotionModalRef.value);
          emit('close');
          emit('getAllProduit',data.data);
        }
        }).catch(({ response }) => {
          error(response.data.message);
        });
    };

      watch(() => props.selectedProduit, (newValue) => {
        selectedProduit.value = newValue;
      if(newValue){
        selectedProduitId.value = newValue.id;
        sale_priceProd.value = newValue.sale_price;
        // fetchCategories(selectedProduitId.value);
      }
    });
  
      onMounted(() => {
      if(route.params.id) {
        getProduit(parseInt(route.params.id as string));
      }
    });
  
      return {promotionSchema,
        addPromotion,
         promotionForm,
         addAddPromotionModalRef,
          getProduit,
          selectedProduitId,
          sale_price,sale_priceProd
         };
    },
  };
  </script>